import { Planet } from '@apeiron/planet'
import { MayNull } from '@apeiron/temp'
import { NextSeo } from 'next-seo'
import * as R from 'ramda'
import { FC } from 'react'

const PlanetOgData: FC<Props> = props => {
  const { planet } = props

  return R.isNotNil(planet) ? (
    <NextSeo
      title={planet.name}
      openGraph={{
        images: [
          {
            url: planet.image || ''
          }
        ]
      }}
    />
  ) : (
    <></>
  )
}

type Props = {
  planet?: MayNull<Planet>
}

export default PlanetOgData
